import { createSlice } from '@reduxjs/toolkit';
import { getSearch, setSearch } from '../../search-and-filter-schema/protected';
import { DEFAULT_CHAT_FILTERS } from './defaultChatFilters';
import updateChatFiltersByFilterKey from './updateChatFiltersByFilterKey';
const initialState = {
  data: DEFAULT_CHAT_FILTERS
};
export const filterValuesSlice = createSlice({
  name: 'filterValues',
  initialState,
  reducers: {
    clearFilterValues(state) {
      const searchQuery = getSearch(state.data);
      state.data = setSearch(searchQuery, initialState.data);
    },
    clearSearchValue(state) {
      const defaultSearchText = getSearch(initialState.data);
      state.data = setSearch(defaultSearchText, state.data);
    },
    clearSearchAndFilterValues() {
      return initialState;
    },
    setFilterValue(state, {
      payload: {
        filterKey,
        filterValue
      }
    }) {
      state.data = updateChatFiltersByFilterKey(filterKey, filterValue, state.data);
    },
    setFilterValues(state, {
      payload
    }) {
      state.data = state.data.merge(payload);
    }
  }
});
export const {
  actions,
  getInitialState
} = filterValuesSlice;
export default filterValuesSlice.reducer;